module.exports = __webpack_public_path__ + "img/dashboardcard-man-img.08ecfc85.svg";